import { Check, AlertCircle, XCircle } from "lucide-react";
import type { ProductVariant } from "@/lib/shop";

export type StockStatus = "in_stock" | "low_stock" | "out_of_stock";

const LOW_STOCK_THRESHOLD = 5;

export function stockStatusOf(variant: ProductVariant | undefined): StockStatus {
  if (!variant) return "out_of_stock";
  if (variant.inventory === null) return "in_stock";
  if (variant.inventory <= 0) return "out_of_stock";
  if (variant.inventory <= LOW_STOCK_THRESHOLD) return "low_stock";
  return "in_stock";
}

const BASE = "inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold font-body";

export function StockBadge({ status }: { status: StockStatus }) {
  if (status === "in_stock") {
    return (
      <span className={`${BASE} bg-primary/10 text-primary`}>
        <Check size={12} aria-hidden="true" />
        På lager
      </span>
    );
  }
  if (status === "low_stock") {
    return (
      <span className={`${BASE} bg-amber-100 text-amber-700`}>
        <AlertCircle size={12} aria-hidden="true" />
        Få igjen
      </span>
    );
  }
  return (
    <span className={`${BASE} bg-red-100 text-red-700`}>
      <XCircle size={12} aria-hidden="true" />
      Utsolgt
    </span>
  );
}
